module.exports = __webpack_public_path__ + "img/Crepu.fdb5ae45.jpg";